import { ADVANCED_FILTER, DEFAULT_STATE } from '../constants'
import { searchPageStore } from '../index'

/**
 * Sets the advanced filters array
 * @param {string[]} advancedFilters - Array of advanced filter strings
 */
export const setAdvancedFilters = (advancedFilters) => {
  searchPageStore.setState({ advancedFilters })
}

/**
 * Adds an advanced filter to the array
 * @param {string} filter - Advanced filter to add
 */
export const addAdvancedFilter = (filter) => {
  const state = searchPageStore.getState()
  const currentFilters = state.advancedFilters || []

  if (!currentFilters.includes(filter)) {
    searchPageStore.setState({ advancedFilters: [...currentFilters, filter] })
  }
}

/**
 * Removes an advanced filter from the array
 * @param {string} filter - Advanced filter to remove
 */
export const removeAdvancedFilter = (filter) => {
  const state = searchPageStore.getState()
  const currentFilters = state.advancedFilters || []

  searchPageStore.setState({
    advancedFilters: currentFilters.filter((f) => f !== filter),
  })
}

/**
 * Sets the personal filters
 * @param {string|undefined} personalFilter - One of: "wish_list_only", "liked_models_only", or undefined
 */
export const setPersonalFilter = (personalFilter) => {
  searchPageStore.setState({ personalFilter })
}

/**
 * Sets the purchase filters
 * @param {string|undefined} purchaseFilter - "purchased_models_only" or undefined
 */
export const setPurchaseFilter = (purchaseFilter) => {
  searchPageStore.setState({ purchaseFilter })
}

/**
 * Clears all more filters. CGT Standard shares advancedFilters but belongs to the Quality group,
 * so clearQualityContent owns it.
 */
export const clearMoreFilters = () => {
  const { advancedFilters = [] } = searchPageStore.getState()

  searchPageStore.setState({
    advancedFilters: advancedFilters.filter(filter => filter === ADVANCED_FILTER.CGT_STANDARD_ONLY),
    personalFilter: DEFAULT_STATE.personalFilter,
    purchaseFilter: DEFAULT_STATE.purchaseFilter,
  })
}
